export enum Name {
  Case_Create = 'Create case',
  Case_Delete = 'Delete case',
  Case_Restore = 'Restore case',
  Sub_Case_Create = 'Create subcase',
}

type Attribute = {
  [Name.Case_Create]: { caseIds: string; rootCase: 'true' | 'false' };
  [Name.Case_Delete]: { caseIds: string };
  [Name.Case_Restore]: { caseIds: string };
  [Name.Sub_Case_Create]: { caseIds: string; rootCase: 'true' | 'false' };
};

export enum Action {
  Button_Click = 'button clicked',
}

export enum Page {
  Case_Create = 'case/add',
  Case_Process = 'case-process',
  View_Cases = 'view/case-list',
  View_Trash = 'view/trash',
}

type Base = {
  action: Action;
  page: Page;
};

export type AttributeMap = { [P in Name]: Attribute[P] & Base };

export const Monitor = {
  Name,
  Action,
  Page,
};
